'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

require("../_assets/IconLoading-B5l-en5n.css");var styles = {"dash":"IconLoading__TrwG0T9q3u__dash","spin":"IconLoading__TrwG0T9q3u__spin","spinner":"IconLoading__TrwG0T9q3u__spinner"};

const IconLoading = icons_Icon.iconFactory('IconLoading', jsxRuntime.jsx("circle", { cx: "12", cy: "12", r: "7.5", strokeWidth: "3", "data-icon-type": "stroke", fill: "transparent" }), {
    className: styles.spinner,
});

exports.IconLoading = IconLoading;
//# sourceMappingURL=IconLoading.js.map
